import formatSsn from './formatSsn';

// \u25CF is the black dot character code
// Creates a string full of black dots that is the same length as the value, then passes the dots into formatSsn
// Used when displaying the SSN value as a masked string of dots
const formatSsnHidden = value => formatSsn('\u25CF'.repeat(value ? value.length : 0));

export default formatSsnHidden;
